"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEthListenerValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const types_1 = require("@framework/types");
exports.addEthListenerValidationSchema = (0, yup_1.object)().shape({
    address: yup_rules_eth_1.addressValidationSchema,
    listenerType: (0, yup_1.mixed)().oneOf(Object.values(types_1.ListenerType)).required("form.validations.valueMissing"),
    fromBlock: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(1, "form.validations.rangeUnderflow"),
    chainId: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(1, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map